module.exports = __webpack_public_path__ + "img/articles3.04d9b0c8.svg";